import { createStyles } from '@mantine/styles';
var useStyles = createStyles(function () {
  return {
    close: {
      marginLeft: "auto",
      marginRight: 0
    }
  };
});
export default useStyles;